import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AlertDialogService } from '../../../../services/alert-dialog.service';
import { EstablishmentService } from '../../../../services/establishment.service';

@Component({
  selector: 'app-third-form-step',
  templateUrl: './third-form-step.component.html',
  styleUrl: './third-form-step.component.scss',
})
export class ThirdFormStepComponent implements OnInit {
  @Input() firstStepFormControl: FormGroup;
  @Input() secondStepFormControl: FormGroup;
  @Input() thirdStepFormControl: FormGroup;
  @Input() addressForm: FormGroup;

  @Output() onSubmit = new EventEmitter<any>();
  @Output() addNewSite = new EventEmitter<any>();
  @Input() removeNewSite: Function;

  addressList: any[] =[];
  addressImages: any[] = [[]];
  etablissementType = [
    { value: 'Établissement public MCO', label: 'Établissement public MCO' },
    { value: 'Clinique Privée', label: 'Clinique Privée' },
    { value: 'Hôpital Universitaire', label: 'Hôpital Universitaire' },
    {
      value: 'Centre de Soins de Longue Durée (CSLD)',
      label: 'Centre de Soins de Longue Durée (CSLD)',
    },
    {
      value: 'Centre de Rééducation et de Réadaptation',
      label: 'Centre de Rééducation et de Réadaptation',
    },
    {
      value: 'Centre de Soins Palliatifs',
      label: 'Centre de Soins Palliatifs',
    },
    { value: 'Centre de Psychiatrie', label: 'Centre de Psychiatrie' },
  ];
  salaryNumber = [
    { value: '10 - 50', label: '10 - 50' },
    { value: '50 - 100', label: '50 - 100' },
    { value: '100 - 500', label: '100 - 500' },
    { value: '500 - 1000', label: '500 - 1000' },
    { value: 'Plus de 1000', label: 'Plus de 1000' },
  ];
  annuelNumber = [
    { value: '50 - 100', label: '50 - 100' },
    { value: '100 - 500', label: '100 - 500' },
    { value: '500 - 1000', label: '500 - 1000' },
    { value: '1000 - 2000', label: '1000 - 2000' },
    { value: 'Plus de 2000', label: 'Plus de 2000' },
  ];
  showPassword: boolean;

  constructor(
    private alertDialogService: AlertDialogService,
    private establishmentService: EstablishmentService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {

  }

  getImagesAddress(index: number): string[] {
    const firstPhoto =
      this.adressesControl.controls[index]?.get('firstPhoto')?.value;
    const secondPhoto =
      this.adressesControl.controls[index]?.get('secondPhoto')?.value;

    const images: string[] = [];
    if (firstPhoto) {
      images.push(firstPhoto);
    }
    if (secondPhoto) {
      images.push(secondPhoto);
    }
    return images;
  }

  getAddresses(wordKey: string, index: number) {
    this.adressesControl.controls[index].get('adress')?.markAsTouched();
    this.adressesControl.controls[index].get('regionCode')?.markAsTouched();
    if (wordKey) {
      this.establishmentService
        .getAddress(wordKey, 'france')
        .subscribe((value) => {
          this.addressList = value.filter(
            (value: any) => value.address.country_code === 'fr'
          );
        });
    } else {
      this.adressesControl.controls[index].get('adress')?.patchValue('');
      this.adressesControl.controls[index].get('regionCode')?.patchValue('');
      this.adressesControl.controls[index].get('regionName')?.patchValue('');
      this.adressesControl.controls[index].markAsTouched();
    }
  }
getAdresseFormated(option: any) {
    const address = option?.address || {};
    const house_number = address?.house_number || '';
    const road = address?.road || ''; 
    const postcode = address?.postcode || ''; 
    const city = address?.city || ''; 
    const country = address?.country || ''; 
    const addressComponents = [
        house_number,
        road,
        `${postcode} ${city}`,
        country
    ];
    const filteredComponents = addressComponents.filter(component => component.trim() !== '');
    return filteredComponents.join(', ')
}
  addressSelected(item: any, index: number): void {
    const address = item?.address || {};
    const group = this.adressesControl.controls[index];
    group.get('lat')?.patchValue(+item.lat);
    group.get('lon')?.patchValue(+item.lon);
    group.get('address')?.patchValue(this.getAdresseFormated(item));
    group.get('adress')?.patchValue(this.getAdresseFormated(item));
    group.get('codePostale')?.patchValue(address.postcode);
    group.get('pays')?.patchValue(address.country);
    group.get('ville')?.patchValue(address.city);
    // Département = county (e.g. "Ain"), not the city (e.g. "Bourg-en-Bresse").
    group.get('departmentName')?.patchValue(address.county || address.city);
    if (!address.postcode) {
      return;
    }
    this.establishmentService.getRegionByPostalCode(address.postcode).subscribe({
      next: (res) => {
        const code = res?.[0]?.codeRegion;
        if (!code) {
          return;
        }
        group.get('regionCode')?.patchValue(code);
        this.establishmentService.getRegionByCode(code).subscribe({
          next: (region) => {
            group.get('regionName')?.patchValue(region?.nom || '');
          },
          error: () => {},
        });
      },
      error: () => {},
    });
  }

  addAddress() {
    this.adressesControl.push(this.fb.group({
      name: ['', Validators.required],
      adress: ['', Validators.required],
      pays: ['', Validators.required],
      codePostale: ['', Validators.required],
      regionCode: ['', Validators.required],
      regionName: ['', Validators.required],
      ville: ['', Validators.required],
      departmentName: ['', Validators.required],
      addressImages: [[]],
      cededx: [''],
      firstPhoto: [''],
      secondPhoto: [''],
      lat: [<number | null>null],
      lon: [<number | null>null],
    }));
    this.addressImages.push([])
    // this.addressForm.reset()
  }


  autoCompleteOnChange(event: any, index: number) {
    this.getAddresses(event?.value, index);
  }

  get adressesControl(): FormArray {
    return this.thirdStepFormControl?.get('adresses') as FormArray;
  }
  deleteNewSite(index: number): void {
    this.alertDialogService
      ?.openAlertModal(
        'success',
        'Confirmation',
        'Êtes-vous sûr(e) de vouloir supprimer cette adresse ? Toutes les informations associées seront perdues. Confirmez la suppression pour continuer.',
        'Supprimer',
        'Annuler'
      )
      ?.subscribe((res) => {
        if (res) {
          this.addressImages.slice(index, 1);
          this.adressesControl.removeAt(index);
        }
      });
  }

  getImage(images: string[], index: number) {
    const addressImages: string[] = []
    this.adressesControl.controls[index].get('firstPhoto')?.patchValue('');
    this.adressesControl.controls[index].get('secondPhoto')?.patchValue('');
    this.adressesControl.controls[index].get('addressImages')?.patchValue([]);

    if (images[0]) {
      addressImages[0] = images[0];
      this.adressesControl.controls[index]
        .get('firstPhoto')
        ?.patchValue(images[0]);
    }
    if (images[1]) {
      addressImages[1] = images[1];
      this.adressesControl.controls[index]
        .get('secondPhoto')
        ?.patchValue(images[1]);
    }
    this.adressesControl.controls[index].get('addressImages')?.patchValue(addressImages);
  }

  addressValidation(index: number): boolean {
    return this.adressesControl.controls[index].valid;
  }
}
